module.exports = __webpack_public_path__ + "static/truworth_care_story_thumbnail-db0526116714004b175d10a6dba599ba.png";